module.exports = __webpack_public_path__ + "img/no-data1.6ce3959b.png";